export default __webpack_public_path__ + "static/xcelerator-99075cb025e7bd3986636743bfa02832.png";